import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const TrainingPrograms = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Training Programs</h2>
                            <p>
                                At Net Nest Badminton Sports Club, our Training Programs are thoughtfully designed to support players at every stage of their badminton journey. From beginners taking their first steps to advanced players preparing for competitive tournaments, our structured programs focus on skill development, physical fitness, mental strength, and long-term growth.
                            </p>
                            <p>
                                <h2>Beginner Training Program</h2>
                                The Beginner Training Program is ideal for newcomers and young players with little or no prior experience. This program introduces the fundamentals of badminton in a friendly and encouraging environment. Players learn the basic rules, correct grip, proper stance, simple footwork, and essential strokes. The focus is on building confidence, coordination, and interest in the sport while maintaining a fun and disciplined learning atmosphere.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Training Programs.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Intermediate Training Program</h2>
                            <p>
                                The Intermediate Training Program is designed for players who have basic knowledge of badminton and want to improve their overall performance. Training focuses on refining stroke techniques, improving footwork speed, developing rally consistency, and understanding tactical play. Regular practice matches and guided feedback help players enhance court awareness and decision-making skills.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Advanced & Competitive Training Program</h2>
                            <p>
                                This program is tailored for serious and competitive players aiming to perform at higher levels. It involves high-intensity training sessions focused on advanced techniques, tactical planning, speed, stamina, and match preparation. Players receive guidance on tournament strategies, pressure handling, and performance analysis to build confidence and competitive mindset.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Youth Development Program</h2>
                            <p>
                                Our Youth Development Program focuses on identifying and nurturing young talent at an early age. Training methods are age-appropriate and emphasize strong fundamentals, agility, coordination, and discipline. This program helps young players develop confidence, sportsmanship, and readiness for school-level and district-level competitions.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Personalized Training Program</h2>
                            <p>
                                The Personalized Training Program offers one-on-one or small-group coaching for players who require individual attention. Training plans are customized based on a player’s strengths, weaknesses, and goals. This program is ideal for skill-specific improvement such as footwork, smash technique, net play, or fitness enhancement.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Fitness & Conditioning Program</h2>
                            <p>
                                Badminton is a physically demanding sport, and fitness plays a crucial role in performance. Our Fitness & Conditioning Program focuses on agility, endurance, strength, flexibility, and injury prevention. Structured fitness routines help players stay fit, fast, and match-ready while reducing the risk of injuries.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Recreational Training Program</h2>
                            <p>
                                This program is designed for adults and working professionals who want to enjoy badminton while staying active and healthy. It focuses on regular play, basic skill improvement, and fitness in a relaxed yet professional environment.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TrainingPrograms;
